import { useState, useEffect } from 'react';
var mobileScreenWidth = 580;
var tabletScreenWidth = 980;
function useMatchScreenWidth(screenWidth) {
    var _a = useState(false), matchesScreenWidth = _a[0], setMatchesScreenWidth = _a[1];
    useEffect(function () {
        function checkMatchesScreenWidth() {
            console.log('callBack', screenWidth);
            if (screenWidth === 'mobile') {
                setMatchesScreenWidth(window.innerWidth <= mobileScreenWidth);
                return;
            }
            if (screenWidth === 'tablet') {
                setMatchesScreenWidth(window.innerWidth <= tabletScreenWidth);
                return;
            }
            setMatchesScreenWidth(window.innerWidth <= screenWidth);
        }
        checkMatchesScreenWidth();
        window.addEventListener('resize', checkMatchesScreenWidth);
        return function () { return window.removeEventListener('resize', checkMatchesScreenWidth); };
    }, []);
    return matchesScreenWidth;
}
export { useMatchScreenWidth };
